import { Category } from "@models";
import { categoryService } from "@services";
import { makeAutoObservable, runInAction } from "mobx";

export default class CategoryStore {
  categories: Category[] = [];
  townCategories: Category[] = [];
  loading = false;
  townLoading = false;
  /** True once a fetch settled — lets views tell "empty" from "not fetched yet". */
  loaded = false;
  townLoaded = false;
  /** Town whose categories are currently held in `townCategories`. */
  townCategoriesTownId: number | undefined = undefined;

  constructor() {
    makeAutoObservable(this);
  }

  getAll = async () => {
    if (this.loading) return;

    this.loading = true;
    try {
      const categories = await categoryService.getAll();
      runInAction(() => {
        this.categories = categories;
      });
    } catch (error) {
      console.error(error);
    } finally {
      runInAction(() => {
        this.loading = false;
        this.loaded = true;
      });
    }
  };

  getByTown = async (townId: number) => {
    runInAction(() => {
      // Drop another town's list so it can't be shown while this one loads.
      if (this.townCategoriesTownId !== townId) {
        this.townCategories = [];
        this.townLoaded = false;
        this.townCategoriesTownId = townId;
      }
      this.townLoading = true;
    });
    try {
      const categories = await categoryService.getByTown(townId);
      runInAction(() => {
        this.townCategories = categories;
      });
    } catch (error) {
      console.error(error);
      runInAction(() => {
        this.townCategories = [];
      });
    } finally {
      runInAction(() => {
        this.townLoading = false;
        this.townLoaded = true;
      });
    }
  };
}
